module.exports = __webpack_public_path__ + "static/blog54-d87de5589009fa63945b0779a74b9d14.png";